"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExampleReactiveSearchProviderCollection = void 0;
const react_1 = __importDefault(require("react"));
const components_1 = require("../../components");
const ExampleReactiveSearchProviderCollection = () => (react_1.default.createElement(components_1.ReactifySearchProvider, { mode: "collection", shopifyPermanentDomain: "usereactify-demo.myshopify.com", collectionHandle: "example-collection" },
    react_1.default.createElement(react_1.default.Fragment, null)));
exports.ExampleReactiveSearchProviderCollection = ExampleReactiveSearchProviderCollection;
//# sourceMappingURL=ExampleReactiveSearchProviderCollection.js.map